import * as React from "react";

export const IconImportFile = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_46251_46562)">
      <path
        d="M11.6663 1.66797L4.99967 1.66797C4.08301 1.66797 3.34134 2.41797 3.34134 3.33464L3.33301 16.668C3.33301 17.5846 4.07467 18.3346 4.99134 18.3346L14.9997 18.3346C15.9163 18.3346 16.6663 17.5846 16.6663 16.668V6.66797L11.6663 1.66797ZM14.9997 16.668H4.99967L4.99967 3.33464L10.833 3.33464V7.5013L14.9997 7.5013V16.668Z"
        fill="currentColor"
      />
      <path
        d="M13.333 12.4904L12.158 11.3154L10.833 12.632V9.16536H9.16634V12.632L7.84134 11.307L6.66634 12.4904L9.99134 15.832L13.333 12.4904Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_46251_46562">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
